import Backbone from 'backbone'
import OrganizationTemplatePermission from './organization-template-permission'

/**
 * @see OrganizationTemplatePermission.kt
 */
const OrganizationTemplatePermissions = Backbone.Collection.extend({
	model: OrganizationTemplatePermission
})

export default OrganizationTemplatePermissions

OrganizationTemplatePermissions.__filename__ = 'organizations/organization-template-permissions.js'
